var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMindsetInspiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1080.000000pt",
    height: "1080.000000pt",
    viewBox: "0 0 1080.000000 1080.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1080.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5120 9423 c-85 -7 -209 -25 -275 -39 -146 -32 -432 -121 -520 -163 -144 -67 -341 -169 -400 -206 -218 -135 -519 -401 -681 -604 -296 -369 -511 -836 -583 -1266 -87 -517 -36 -1030 147 -1485 118 -294 205 -436 632 -1030 369 -512 521 -769 644 -1090 64 -164 67 -170 95 -189 23 -14 140 -16 1221 -19 1124 -2 1197 -1 1230 15 38 20 47 35 85 138 100 269 294 620 504 910 51 69 342 477 394 550 209 296 327 516 429 800 110 304 168 695 154 1025 -24 569 -222 1108 -580 1585 -67 90 -346 373 -446 454 -36 29 -74 60 -85 70 -34 29 -188 135 -225 154 -19 10 -60 32 -90 50 -69 40 -273 137 -366 172 -113 44 -290 98 -359 110 -22 4 -74 15 -115 25 -90 22 -416 51 -555 49 -55 -1 -170 -8 -255 -16z m451 -1007 c55 -35 85 -78 104 -153 19 -72 19 -106 0 -171 -35 -117 -111 -164 -318 -193 -406 -59 -597 -145 -817 -368 -218 -220 -320 -436 -356 -751 -22 -191 -45 -263 -103 -320 -72 -71 -106 -83 -220 -78 -86 3 -102 7 -142 32 -116 73 -140 191 -98 477 90 615 446 1109 997 1383 133 66 264 110 440 147 122 25 155 28 302 26 163 -2 166 -2 211 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4199 2775 c-36 -19 -40 -58 -29 -237 23 -365 129 -622 354 -856 105 -109 200 -179 332 -246 182 -91 335 -126 564 -126 158 0 230 10 360 50 318 98 590 328 730 615 97 200 126 315 142 565 10 158 9 190 -3 215 l-14 30 -1205 2 c-1026 2 -1209 0 -1231 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindsetInspiration);
export default __webpack_public_path__ + "static/media/mindset-inspiration.7dbb001db6f1476c0cef9e473999b460.svg";
export { ForwardRef as ReactComponent };